import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mantine/core";
import { Cubby } from "../stores/Cubby";
import { Menu, rem } from "@mantine/core";
import {
  IconSettings,
  IconTrash,
  IconEdit,
  IconInfoHexagon,
  IconCircleCheck,
  IconAlertOctagon,
  IconBolt,
  IconTools,
  IconMenu,
  IconMenu2,
  IconDatabase,
  IconBoltFilled,
  IconHistory,
  IconArrowBigUpFilled,
  IconCoinBitcoin,
  IconCircleMinus,
} from "@tabler/icons-react"; // Updated icons
import { MODALS } from "../helpers/constants";

const DataMenu = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button leftSection={<IconHistory />} variant="default">
          History
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {cubby.payOffchainEvents.data.length > 0 && (
          <Menu.Item
            leftSection={<IconBoltFilled />}
            onClick={() => {
              cubby.setModal(MODALS.LIGHTNING_OUTBOUND_EVENTS);
            }}
          >
            Lightning Sent
          </Menu.Item>
        )}
        {cubby.invoiceUpdateEvents.data.length > 0 && (
          <Menu.Item
            leftSection={<IconBolt />}
            onClick={() => {
              cubby.setModal(MODALS.LIGHTNING_INBOUND_EVENTS);
            }}
          >
            Lightning Received
          </Menu.Item>
        )}

        {cubby.onchainPaymentSuccesses.data.length > 0 && (
          <Menu.Item
            leftSection={<IconArrowBigUpFilled />}
            onClick={() => {
              cubby.setModal(MODALS.BITCOIN_WITHDRAWAL_EVENTS);
            }}
          >
            Bitcoin Withdrawals
          </Menu.Item>
        )}

        {cubby.onchainTransactions?.data.length > 0 && (
          <Menu.Item
            leftSection={<IconCoinBitcoin />}
            onClick={() => {
              cubby.setModal(MODALS.BITCOIN_ONCHAIN_TRANSACTIONS);
            }}
          >
            On-chain Transactions
          </Menu.Item>
        )}
        {cubby.cubbyErrors.data.length > 0 && (
          <Menu.Item
            leftSection={<IconAlertOctagon />}
            onClick={() => {
              cubby.setModal(MODALS.CUBBY_ERRORS);
            }}
          >
            Errors
          </Menu.Item>
        )}
        {cubby.closedChannels.length > 0 && (
          <Menu.Item
            leftSection={<IconCircleMinus />}
            onClick={() => {
              cubby.setModal(MODALS.CLOSED_CHANNELS);
            }}
          >
            Closed Channels
          </Menu.Item>
        )}

        {/* <Menu.Divider />

        <Menu.Label>some menu label</Menu.Label> */}
      </Menu.Dropdown>
    </Menu>
  );
});

export default DataMenu;
